import { OrderSheetItemData } from "../api/models/OrderSheetData";
import { removeDuplicates } from "../ProductsSearch/reducers/ProductsSearchRdc";

export const validateEmail = (email: string) => {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return email !== '' && re.test(String(email).toLowerCase()) === true
}

export const validatePassword = (password: string) => {
    let re = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    return password !== '' && re.test(password) === true
}

export const validateABN = (text: string) => {
    let re = new RegExp("^[0-9]{11}$");
    return text !== '' && re.test(text) === true
}

export const validatePhoneNumber = (phoneNumber: string) => {
    let re = new RegExp(/^(\+)?[0-9]{7,15}$/)
    return phoneNumber !== '' && re.test(phoneNumber) === true
}

export const validatePostalCode = (postalCode: string) => {
    let re = new RegExp(/^(?!6797|6798|6799)(?:(?:[1-9]\d|0?[289])(?:\d{2})$)/);
    return postalCode !== '' && re.test(postalCode) === true
}

export const WrongEmailFormatText: string = 'Provided e-mail is in wrong format.'
export const WrongABNFormatText: string = 'Provided ABN is in wrong format.'
export const WrongPostalCodeFormatText: string = 'Provided postal code is in wrong format. Eg: for NT, valid code is 0800.'
export const WrongPhoneNumberFormatText: string = 'Provided phone number is in wrong format.'


export const containsSameProduct = (osidList: OrderSheetItemData[], osidToFind: OrderSheetItemData) => {
    return osidList.find(o => OrderSheetItemData.getSignature(o) === OrderSheetItemData.getSignature(osidToFind)) !== undefined
}